// Google Maps loader service - runtime-loads the API key from /api/config.

// Fallback browser key. Google Maps browser keys are public by design (they
// ship in the script URL to every visitor); access control comes from the
// key's website restrictions in Google Cloud Console, not secrecy.
const PUBLIC_BROWSER_MAPS_KEY = 'AIzaSyD9JbNylGPyz1c6q4TDaJitKj5zCD_ALl4';
let loadPromise: Promise<void> | null = null;
const SCRIPT_ID = 'google-maps-js-api';
const LIBRARIES = 'drawing,places,marker,visualization,maps3d';

async function loadMapsApiKey(): Promise<string> {
  const res = await fetch('/api/config', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error('Google Maps config failed to load');
  }
  const config = await res.json().catch(() => ({}));
  const key = typeof config?.googleMapsApiKey === 'string' ? config.googleMapsApiKey.trim() : '';
  if (!key) {
    return PUBLIC_BROWSER_MAPS_KEY;
  }
  return key;
}

export function loadGoogleMaps(): Promise<void> {
  if (window.google?.maps) {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = loadMapsApiKey().then((apiKey) => new Promise<void>((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('Google Maps API failed to load')), { once: true });
      if (window.google?.maps) {
        resolve();
      }
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&v=beta&libraries=${encodeURIComponent(LIBRARIES)}&loading=async`;
    script.onload = () => {
      if (window.google?.maps) {
        console.log('Google Maps API loaded');
        resolve();
      } else {
        reject(new Error('Google Maps API loaded without maps namespace'));
      }
    };
    script.onerror = () => reject(new Error('Google Maps API failed to load'));
    document.head.appendChild(script);
  }));

  return loadPromise;
}

export function isGoogleMapsLoaded(): boolean {
  return !!window.google?.maps;
}
